export const convertDegreesToRadians = (degrees) => degrees * (Math.PI / 180);

// TODO add default value for entry
export const getCurrentLayoutProperty = (propertyObj) => (props) =>
  propertyObj[Object.entries(props?.layout || {isMobile: true}).find(([_, value]) => value)?.[0]];
